<template>
  <MainLoader v-if="isLoading" />
  <div v-else class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <h2 class="text-2xl font-bold text-brand-800 mb-6">
      Table Columns Customizer
    </h2>

    <div class="mb-6">
      <p class="text-gray-600 mb-4">
        Select which columns to display in your table:
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div
          v-for="column in allColumns"
          :key="column.id"
          class="flex items-center p-3 border rounded-lg hover:border-brand-300 hover:bg-gray-50 transition-colors cursor-pointer"
          :class="{
            'border-accent-500 bg-accent-50 text-accent-700': selectedColumns?.includes(column.id),
            'border-gray-200 bg-white': !selectedColumns?.includes(column.id),
          }"
          @click="toggleColumn(column.id)"
        >
          <input
            type="checkbox"
            :id="'column-' + column.id"
            :checked="selectedColumns?.includes(column.id)"
            class="h-4 w-4 text-accent-500 border-gray-300 rounded focus:ring-accent-500"
            @change="toggleColumn(column.id)"
            @click.stop
          />
          <label
            :for="'column-' + column.id"
            class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer"
          >
            {{ column.title }}
          </label>
        </div>
      </div>
    </div>

    <div class="flex justify-end space-x-4 pt-4 border-t border-gray-200">
      <button
        @click="saveColumns"
        class="px-4 py-2 bg-accent-gradient hover:brightness-105 text-white rounded-md text-sm font-medium focus:outline-none"
      >
        Save Configuration
      </button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import MainLoader from "@/components/MainLoader.vue";
export default {
  components: { MainLoader },
  setup() {
    const store = useStore();
    const allColumns = ref([]);
    const currentUser = store.state.users.user;
    const selectedColumns = ref([]);
    const isLoading = ref(false);

    const loadColumns = async () => {
      try {
        isLoading.value = true;
        const userCols = await store.dispatch("getUserCols", {
          id_user: currentUser.id_user,
        });
        if (userCols) {
          selectedColumns.value = userCols;
        }

        let cols = await store.dispatch("getSSConfig");
        cols = cols.filter((column) => column.match_key !== "SHEET");
        allColumns.value = cols;
      } catch (error) {
        console.error("Error loading columns:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const toggleColumn = (columnId) => {
      if (selectedColumns.value?.includes(columnId)) {
        selectedColumns.value = selectedColumns.value.filter(
          (id) => id !== columnId
        );
      } else {
        selectedColumns.value.push(columnId);
      }
    };

    const saveColumns = async () => {
      isLoading.value = true;
      await store.dispatch("saveColumns", {
        columns: selectedColumns.value,
        id_user: currentUser.id_user,
      });
      isLoading.value = false;
    };

    onMounted(() => {
      loadColumns();
    });

    return {
      allColumns,
      selectedColumns,
      toggleColumn,
      saveColumns,
      isLoading,
    };
  },
};
</script>